import {
  useAPIGetActiveSelection,
  useAPIGetRequestAllocationApproval,
} from 'api/ps/useAPISelectionPS'
import { useAPIGetStatusUsulan } from 'api/usulan/useAPIUsulan'
import { useMemo } from 'react'

import { useRoles } from 'utils/hooks'
import { useRegionContext } from 'utils/hooks/useRegion'

enum PSPreSelectionStep {
  PENGAJUAN_FORMASI = 1,
  UNDANG_BCPS = 2,
  FINALISASI_BCPS = 3,
}

const usePSActiveSelection = () => {
  const { regionDetail } = useRegionContext()
  const { isDinasUser } = useRoles()
  const {
    data: responseGetActiveSelection,
    isLoading: isLoadingActiveSelection,
    refetch: refetchActiveSelection,
  } = useAPIGetActiveSelection({
    regionId: regionDetail.id,
    regionType: regionDetail.type,
  })
  const {
    data: responseGetRequestAllocationApproval,
    isLoading: isLoadingRequestAllocationApproval,
    refetch: refetchRequestAllocationApproval,
  } = useAPIGetRequestAllocationApproval({
    regionId: regionDetail.id,
    regionType: regionDetail.type,
  })

  const { selection: activeSelection } = responseGetActiveSelection ?? {}

  const { data: usulan, refetch: refetchStatusUsulan } = useAPIGetStatusUsulan(
    'seleksi-pengawas-sekolah',
    activeSelection?.id,
    {
      queryConfig: {
        enabled: ['PENGUSULAN_BKN', 'FINALIZATION'].includes(
          activeSelection?.state
        ),
      },
    }
  )

  const refresh = () => {
    refetchActiveSelection()
    refetchRequestAllocationApproval()
    refetchStatusUsulan()
  }

  const isLoading =
    isLoadingActiveSelection || isLoadingRequestAllocationApproval

  const canStartSelection =
    isDinasUser && responseGetRequestAllocationApproval?.status === 'APPROVED'

  const currentStep = useMemo(() => {
    if (isLoading) return

    if (
      activeSelection?.state === 'INTIALIZATION' &&
      responseGetRequestAllocationApproval?.status === 'APPROVED'
    ) {
      return PSPreSelectionStep.UNDANG_BCPS
    }

    if (['FINALIZATION', 'PENGUSULAN_BKN'].includes(activeSelection?.state)) {
      return PSPreSelectionStep.FINALISASI_BCPS
    }

    return PSPreSelectionStep.PENGAJUAN_FORMASI
  }, [
    isLoading,
    activeSelection?.state,
    responseGetRequestAllocationApproval?.status,
  ])

  const isOnStepPengajuanFormasi =
    currentStep === PSPreSelectionStep.PENGAJUAN_FORMASI

  const isOnStepUndangBCPS = currentStep === PSPreSelectionStep.UNDANG_BCPS

  const isOnStepFinalisasiBCPS =
    currentStep === PSPreSelectionStep.FINALISASI_BCPS

  return {
    isLoading,
    activeSelection,
    isOnStepPengajuanFormasi,
    isOnStepUndangBCPS,
    isOnStepFinalisasiBCPS,
    allocationApprovalStatus: responseGetRequestAllocationApproval?.status,
    canStartSelection,
    usulan,
    refresh,
  }
}

export default usePSActiveSelection
